/**
 * Survives a `CaptureScreen` remount within the same page load - specifically, the redirect
 * to `/iniciar-sesion` and back that an expired session triggers mid-upload
 * (`docs/implementation/06-mobile-web.md` 6.2: "without losing the user's captured photo or
 * in-flight idempotency key if avoidable"). A plain module-level variable is enough: it is not
 * React state, so it outlives the component instance that saved it, and it does not need to
 * survive a full page reload (V1 has no offline queue, so a reload mid-upload is not a case
 * this needs to cover).
 */
export interface CaptureAttempt {
  readonly file: File;
  /** `URL.createObjectURL(file)` - kept alive (not revoked) while an attempt is saved. */
  readonly previewUrl: string;
  readonly idempotencyKey: string;
  readonly capturedAt: string | undefined;
}

let pending: CaptureAttempt | null = null;

export function saveCaptureAttempt(attempt: CaptureAttempt): void {
  pending = attempt;
}

/** Reads and clears in one step, so a later fresh visit never resurrects a stale attempt. */
export function takeCaptureAttempt(): CaptureAttempt | null {
  const attempt = pending;
  pending = null;
  return attempt;
}
